export const WELCOME = 'welcome';
export const WELCOME_BACK = 'welcomeBack';
export const SAVE = 'saveCTA';
